
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type specificationsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function specificationsRT(): TemplateResult<specificationsRTRootProps> {
    function repeatPart1(productSpecifications, part, partIndex) {
        return _createElement('button', {
            'className': 'cm_specifications-button' + (partIndex === 0 ? ' cm_specifications-button-active' : ''),
            'onClick': e => window.Convermax.handlePDPTableTabs(e, part.PartNumber, 'cm_specifications')
        }, '\n      ', part.Title, '\n    ');
    }
    function scopeFieldValue2(productSpecifications, part, partIndex, specifications, middle, slices, slice, sliceIndex, specification, specificationIndex) {
        var field = specification[0];
        var value = specification[1];
        return _createElement('div', {
            'className': 'fitment-row',
            'key': field
        }, _createElement('div', { 'className': 'fitment-cell' }, _createElement('div', { 'className': 'fitment-cell__value' }, field)), _createElement('div', { 'className': 'fitment-cell' }, _createElement('div', { 'className': 'fitment-cell__value' }, value)));
    }
    function repeatSpecification3(productSpecifications, part, partIndex, specifications, middle, slices, slice, sliceIndex, specification, specificationIndex, field, value) {
        return scopeFieldValue2.apply(this, [
            productSpecifications,
            part,
            partIndex,
            specifications,
            middle,
            slices,
            slice,
            sliceIndex,
            specification,
            specificationIndex
        ]);
    }
    function repeatSlice4(productSpecifications, part, partIndex, specifications, middle, slices, slice, sliceIndex) {
        return [_createElement.apply(this, [
                'div',
                {
                    'className': 'fitment-table-body fitment-table-fitment cm_mobile-hide',
                    'key': '12421'
                },
                _map(slice, repeatSpecification3.bind(this, productSpecifications, part, partIndex, specifications, middle, slices, slice, sliceIndex))
            ])];
    }
    function scopeMiddleSlices5(productSpecifications, part, partIndex, specifications) {
        var middle = Math.ceil(specifications.length / 2);
        var slices = [
            specifications.slice(0, middle),
            specifications.slice(middle)
        ];
        return [_map(slices, repeatSlice4.bind(this, productSpecifications, part, partIndex, specifications, middle, slices))];
    }
    function scopeFieldValueIsHidden6(productSpecifications, part, partIndex, specifications, isCollapsible, specification, specificationIndex) {
        var field = specification[0];
        var value = specification[1];
        var isHidden = specificationIndex > 7;
        return _createElement('div', {
            'cm-data-hidden': isHidden ? 'true' : 'false',
            'className': 'fitment-row' + (isHidden ? ' cm_hide' : ''),
            'key': field
        }, _createElement('div', { 'className': 'fitment-cell' }, _createElement('div', { 'className': 'fitment-cell__value' }, field)), _createElement('div', { 'className': 'fitment-cell' }, _createElement('div', { 'className': 'fitment-cell__value' }, value)));
    }
    function repeatSpecification7(productSpecifications, part, partIndex, specifications, isCollapsible, specification, specificationIndex, field, value, isHidden) {
        return scopeFieldValueIsHidden6.apply(this, [
            productSpecifications,
            part,
            partIndex,
            specifications,
            isCollapsible,
            specification,
            specificationIndex
        ]);
    }
    function scopeIsCollapsible8(productSpecifications, part, partIndex, specifications) {
        var isCollapsible = specifications.length > 7;
        return [
            _createElement.apply(this, [
                'div',
                {
                    'className': 'fitment-table-body fitment-table-body-collapsible fitment-table-fitment' + (isCollapsible ? ' cm_fitment-table-body-content-collapsed' : '') + ' cm_desktop-hide',
                    'key': '18041'
                },
                _map(specifications, repeatSpecification7.bind(this, productSpecifications, part, partIndex, specifications, isCollapsible))
            ]),
            isCollapsible ? _createElement('div', {
                'className': 'cm_fitment-table_collapse-button-container cm_desktop-hide',
                'key': '18043'
            }, _createElement('button', {
                'className': 'cm_fitment-table_collapse-button btn btn--primary',
                'onClick': e => window.Convermax.showMoreProductData(e)
            }, '\n              Show More\n            ')) : null
        ];
    }
    function scopeSpecifications9(productSpecifications, part, partIndex) {
        var specifications = Object.entries(part.Values);
        return _createElement('div', { 'className': 'cm_specifications-content cm_specifications-content-' + part.PartNumber + (partIndex === 0 ? ' cm_specifications-content-active' : '') }, _createElement('div', { 'className': 'cm_fitment-table__vertical' }, scopeMiddleSlices5.apply(this, [
            productSpecifications,
            part,
            partIndex,
            specifications
        ]), scopeIsCollapsible8.apply(this, [
            productSpecifications,
            part,
            partIndex,
            specifications
        ])));
    }
    function repeatPart10(productSpecifications, part, partIndex, specifications) {
        return scopeSpecifications9.apply(this, [
            productSpecifications,
            part,
            partIndex
        ]);
    }
    function scopeProductSpecifications11() {
        var productSpecifications = JSON.parse(this.productData[0].value);
        return _createElement('div', {
            'className': 'cm_specifications cm_fitment-table',
            'key': '0'
        }, _createElement('div', { 'className': 'cm_specifications-header' }, _createElement('span', { 'className': 'cm_specifications-header-title' }, 'PRODUCT SPECIFICATIONS')), productSpecifications.length > 1 ? _createElement.apply(this, [
            'div',
            {
                'className': 'cm_specifications-actions',
                'key': '288'
            },
            _map(productSpecifications, repeatPart1.bind(this, productSpecifications))
        ]) : null, _createElement.apply(this, [
            'div',
            { 'className': 'cm_specifications-content-container' },
            _map(productSpecifications, repeatPart10.bind(this, productSpecifications))
        ]));
    }
    return this.productData.length ? scopeProductSpecifications11.apply(this, []) : null;
}
        export const componentNames = []